import React, { useState } from "react";
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from "react-router-dom";

const AddDevice = () => {
  const [devices, setDevices] = useState([
    { id: 1, name: "Device 1" },
    { id: 2, name: "Device 2" },
    { id: 3, name: "Device 3" },
  ]);
  const [distributors, setDistributors] = useState([
    { id: 1, name: "Distributor 1" },
    { id: 2, name: "Distributor 2" },
    { id: 3, name: "Distributor 3" },
  ]);
  const [serialNumbers, setSerialNumbers] = useState([]);
  const navigate = useNavigate();

  const handleAddSerialNumberClick = () => {
    setSerialNumbers([...serialNumbers, ""]);
  };

  const handleDeleteSerialNumberClick = (index) => {
    const newSerialNumbers = [...serialNumbers];
    newSerialNumbers.splice(index, 1);
    setSerialNumbers(newSerialNumbers);
  };

  const handleSerialNumberInputChange = (event, index) => {
    const newSerialNumbers = [...serialNumbers];
    newSerialNumbers[index] = event.target.value;
    setSerialNumbers(newSerialNumbers);
  };
  const handleGoBack = ()=>{
    navigate('/create-devices');
  }

  return (
    <div className="new-device-main">
      <u><h6 className='newDevice-heading'>Device Information</h6></u>
      <hr />
      <div className='newDevice-main'>
      <div className='newDevice-dropDown'>
        <label htmlFor="device-select" className='new-lable'>Device:</label>
        <select id="device-select" className='new-select' onChange={handleSelectDevices}>
          {devices.map((device) => (
            <option key={device.id} value={device.name}>
              {device.name}
            </option>
          ))}
        </select>
      </div>
      <div className='newDevice-dropDown'>
        <label htmlFor="distributor-select" className='new-lable2'>Distributor:</label><br/>
        <select id="distributor-select" className='new-select2'>
          {distributors.map((distributor) => (
            <option key={distributor.id} value={distributor.name}>
              {distributor.name}
            </option>
          ))}
        </select>
      </div>
      </div>
      <div>
      <div>
        <label htmlFor="serial-number-input" className="new-lable-serial">Serial Number:</label><br />
        <input
        className="new-input"
          type="text"
          id="serial-number-input"
          value={serialNumbers[0]}
          onChange={(event) => handleSerialNumberInputChange(event, 0)}
        />
      
      {serialNumbers.map((serialNumber, index) => (
        <div key={index}>
          <label htmlFor={`serial-number-input-${index}`} className="new-lable-serial">Serial Number:</label>
          <input
            type="text"
            className="new-input"
            id={`serial-number-input-${index}`}
            value={serialNumber}
            onChange={(event) => handleSerialNumberInputChange(event, index)}
          />
          <button onClick={() => handleDeleteSerialNumberClick(index)} className="delete-btn"><DeleteIcon className="new-delete" /></button>
        </div>

      ))}
      <button onClick={handleAddSerialNumberClick} className="new-Add-serial">Add More Serial Numbers</button>
      </div>

    </div>
    <div className="new-bottom-btn">
        <button className="new-go-btn" onClick={handleGoBack}> GO Back</button>
        <button className="new-go-btn">Create</button>
    </div>
    </div>
  );
};

export default AddDevice;
